import { useTheme } from '@emotion/react'
import { Box, Paper, useMediaQuery } from '@mui/material'
import React from 'react'
import { variants } from '../variants/variants'
import BackButton from './BackButton'

const NavbarLayout = ({children,handleNavigate,backButton=true}) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  return (
    <Box
        component={Paper}
        elevation={0}
        sx={{
          p: 1,
          border:1,
          borderColor: 'divider',
          background: variants.boxBackground.NAVBAR,
          borderRadius: variants.boxRadius.NAVBAR,
          display: 'flex',
        }}
      >
        {isMobile && backButton&& <BackButton handleNavigate={handleNavigate}/>}
        {children}
        </Box>
  )
}

export default NavbarLayout